// ARIA attributes
export abstract class AriaAttributes {
	public static readonly RECRUITING_TABS = 'recruiting tabs'
	public static readonly RECRUITING_AGENT_PROFILETABS =
		'recruiting agent profile tabs'
	public static readonly BI_TABS = 'business intelligence tabs'
	public static readonly BI_METRIC = 'business intelligence metric dropdown'
	public static readonly BI_SEGMENT = 'business intelligence segment dropdown'
	public static readonly BI_OR_SWITCH =
		'business intelligence other revenue switch'
	public static readonly BI_RADIO_GROUP =
		'business intelligence bechmark radio group'
	public static readonly BI_BENCHMARK_DIALOG =
		'business intelligence bechmark dialog'
	public static readonly BI_BENCHMARK_CHECKBOX =
		'business intelligence bechmark checkbox'
	public static readonly BI_REVENUE_BREAKDOWN =
		'business intelligence revenue breakdown dropdown'
	public static readonly BI_TIMEFRAME_DROPDOWN = 'bi-timeframe-dropdown'
	public static readonly BI_METRIC_DROPDOWN = 'bi-metric-dropdown'
	public static readonly BI_DISPLAY_CATEGORY_MODAL = 'display-category-dialog'
	public static readonly MULTICOMPANY_BRAND_SELECTION = 'multicompany brand selection dropdown'
	public static readonly MULTICOMPANY_COMPANY_SELECTION = 'multicompany company selection dropdown'
}
